<template>
    <div>
        <headline>
            Buchungsregeln
            <template v-slot:more>
                <button-primary @click="open" class="mr-2"><i class="fa fa-plus"></i> Neue Regel</button-primary>
                <user-groups class="mr-2"></user-groups>
                <a href="/admin/pages/zones">
                    <button-secondary>
                        <i class="fa fa-pencil"></i>
                        Zonen verwalten
                    </button-secondary>
                </a>
            </template>
        </headline>

        <loading v-show="isLoading"></loading>

        <card v-show="!isLoading">
            <template v-slot:header>Aktive Buchungsregeln</template>
            <draggable class="mb-8" v-model="allocations" handle=".handle"
                       @end="onChange" v-bind="dragOptions">
                <transition-group>
                    <div v-for="(element, index) in allocations" :key="element.id" class="rounded border mb-2 w-full">
                        <div class="flex justify-between">
                            <div class="flex items-baseline">
                                <div class="flex items-center p-2">
                                    <a class="block flex text-center items-center cursor-move handle">
                                        <i class="fa fa-ellipsis-v"></i>
                                    </a>
                                </div>
                                <div class="p-3">
                                    {{ index + 1 }}
                                </div>
                                <div class="p-3">
                                    {{ element.user_group.name }} - {{ element.zone.name }}
                                    <span v-show="element.always_usable"
                                          class="ml-4 text-gray-500">Permament buchbar</span>
                                </div>
                                <div class="p-3 text-gray-500">
                                    <span
                                        v-show="element.activated_hours_before_day !== null && !element.always_usable">
                                        Tagesbuchung: Erst {{ element.activated_hours_before_day }} Stunden vorher
                                        aktiv.
                                    </span>
                                    <span
                                        v-show="element.activated_hours_before_week !== null && !element.always_usable && element.activated_hours_before_day === null">
                                        Wochenbuchung: Erst {{ element.activated_hours_before_week }} Stunden vorher
                                        aktiv.
                                    </span>
                                </div>
                            </div>
                            <div class="p-2 flex justify-end items-baseline">
                                <allocation-edit @updated="created" class="mr-2"
                                                 :allocation="element"></allocation-edit>
                                <confirm-dialog @confirmed="trash(element.id)">
                                    <template v-slot:question>Soll die Zuordnung wirklich gelöscht werden?</template>
                                    <template v-slot:header>Regel löschen</template>
                                    <template v-slot:confirm>
                                        <button-delete>
                                            <template slot="icon"><i class="fa fa-trash"></i></template>
                                            Zuordnung löschen
                                        </button-delete>
                                    </template>
                                    <button-delete>
                                        <template slot="icon"><i class="fa fa-trash"></i></template>
                                        Zuordnung löschen
                                    </button-delete>
                                </confirm-dialog>
                            </div>
                        </div>
                    </div>
                </transition-group>
            </draggable>
        </card>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">

                <template v-slot:header>Regel hinzufügen</template>

                <loading v-show="isLoading"></loading>

                <div v-if="!isLoading">

                    <select-menu :has-empty-field="true" v-model="user_group" :text="userGroups.map(g => g.name)"
                                 :values="userGroups.map(g => g.id)">
                        Usergruppe
                    </select-menu>

                    <select-menu :has-empty-field="true" v-model="zone" :text="zones.map(g => g.name)"
                                 :values="zones.map(g => g.id)">
                        Zone
                    </select-menu>

                    <input-field class="mt-4 mb-4">
                        <input type="checkbox" v-model="always_usable"> Permanent verfügbar.
                        <template slot="helper">Schreibtische können immer gebucht werden, auch wenn die vorherige
                            Kapazität noch nicht erreicht ist.
                        </template>
                    </input-field>
                    <div class="flex justify-end">
                        <button-primary @click="create">
                            <template slot="icon"><i class="fa fa-plus"></i></template>
                            Regel hinzufügen
                        </button-primary>
                    </div>
                </div>
            </modal>
        </portal>
    </div>
</template>

<script>
import Card from "../components/UI/Card";
import UserGroups from "../components/UserGroups";
import draggable from 'vuedraggable';
import ButtonPrimary from "../components/UI/ButtonPrimary";
import Modal from "../components/Modal";
import ConfirmDialog from "../components/UI/ConfirmDialog";
import Loading from "../components/UI/Loading";
import ButtonWhite from "../components/UI/ButtonWhite";
import Headline from "../components/UI/Headline";
import forEach from "lodash/forEach";
import InputField from "../components/UI/InputField";
import CardFullInvisible from "../components/UI/CardFullInvisible";
import ButtonDelete from "../components/UI/ButtonDelete";
import ButtonSecondary from "../components/UI/ButtonSecondary";
import SelectMenu from "../components/UI/SelectMenu";
import AllocationEdit from "../components/Allocation/AllocationEdit.vue";

export default {
    name: "Allocations",
    components: {
        AllocationEdit,
        SelectMenu,
        ButtonSecondary,
        ButtonDelete,
        CardFullInvisible,
        InputField,
        Headline,
        ButtonWhite,
        Loading,
        ConfirmDialog,
        Modal,
        ButtonPrimary,
        UserGroups,
        Card,
        draggable,
    },


    props: ['group'],

    data: () => ({
        showModal: false,

        zones: [],
        userGroups: [],
        allocations: [],

        user_group: null,
        zone: null,
        always_usable: false,

        loading: 0,
    }),

    created() {
        this.created();
    },

    methods: {
        created() {
            this.loading = 1;
            this.$http.get('/admin/allocations').then(result => {
                this.allocations = result.data.data;
                this.loading--;
            });
        },
        open() {
            this.load();
            this.showModal = true;
        },
        load() {
            this.loading = 2;
            this.$http.get('/admin/zones').then(result => {
                this.zones = [{id: null, name: 'Bitte Auswählen'}].concat(result.data.data);
                this.loading--;
            })
            this.$http.get('/admin/user_groups').then(result => {
                this.userGroups = [{id: null, name: 'Bitte Auswählen'}].concat(result.data.data);
                this.loading--;
            })
        },
        create() {
            this.loading = 1;
            this.$http.post('/admin/allocations', {
                user_group: this.user_group,
                zone: this.zone,
                always_usable: this.always_usable,
            }).then(() => {
                this.loading -= 1;
                this.$root.$emit('alert', 'Neue Regel erstellt.');
                this.created();
                this.showModal = false;
            }).catch(error => {
                this.loading -= 1;
                this.$root.$emit('error', error);
            })
        },
        trash(id) {
            this.loading = 1;
            this.$http.post(`/admin/allocations/${id}`, {
                _method: 'delete',
            }).then(() => {
                this.loading -= 1;
                this.$root.$emit('alert', 'Regel gelöscht.');
                this.created();
            }).catch(error => {
                this.loading -= 1;
                this.$root.$emit('error', error);
            })
        },
        onChange() {
            forEach(this.allocations, (element, index) => {
                element.position = index + 1;
            });
            this.$http.put(`/admin/allocations`, {
                allocations: this.allocations.map(e => ({
                    id: e.id,
                    position: e.position,
                })),
            }).catch(error => {
                this.$root.$emit('error', error);
            });
        },
    },

    computed: {
        isLoading() {
            return this.loading > 0;
        },
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    }
}
</script>

<style scoped>
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
</style>
